import api from '@/api/axiosConfig.js';

function unwrap(response) {
  const payload = response?.data || {};
  if (!payload.ok && payload.success === false) {
    const error = new Error(payload.message || payload.error || 'No se pudo operar con fojas.');
    error.payload = payload;
    throw error;
  }
  return payload.data;
}

export async function listFojas(params = {}) {
  const response = await api.get('/api/fojas', { params });
  return unwrap(response);
}

export async function listFojaLineas(params = {}) {
  const response = await api.get('/api/fojas/lineas', { params });
  return unwrap(response);
}

export async function listGuiasElegibles(params = {}) {
  const response = await api.get('/api/fojas/guias', { params });
  return unwrap(response);
}

export async function getFojaDetail(fojaId) {
  const response = await api.get(`/api/fojas/${fojaId}`);
  return unwrap(response);
}

export async function createFoja(payload) {
  const response = await api.post('/api/fojas', payload);
  return unwrap(response);
}

export async function updateUnreceivedFoja(fojaId, payload) {
  const response = await api.put(`/api/fojas/${fojaId}`, payload);
  return unwrap(response);
}

export async function cancelFoja(fojaId, payload) {
  const response = await api.post(`/api/fojas/${fojaId}/anular`, payload);
  return unwrap(response);
}

export async function emitFoja(payload) {
  const response = await api.post('/api/fojas/emitir', payload);
  return unwrap(response);
}

export async function prevalidateEmitFoja(payload) {
  const response = await api.post('/api/fojas/emitir/prevalidar', payload);
  return unwrap(response);
}

export async function getFojaOperationalPolicy(empresaId) {
  const response = await api.get('/api/fojas/config/politicas-operativas', {
    params: empresaId ? { empresa_id: empresaId } : {},
  });
  return unwrap(response);
}

export async function updateFojaOperationalPolicy(payload) {
  const response = await api.put('/api/fojas/config/politicas-operativas', payload);
  return unwrap(response);
}

export async function closeFoja(fojaId, payload) {
  const response = await api.post(`/api/fojas/${fojaId}/cerrar`, payload);
  return unwrap(response);
}

export async function confirmDispatch(fojaId, payload = {}) {
  const response = await api.post(`/api/fojas/${fojaId}/confirmar-despacho`, payload);
  return unwrap(response);
}

export async function startReception(fojaId) {
  const response = await api.post(`/api/fojas/${fojaId}/recepcion/iniciar`);
  return unwrap(response);
}

export async function closeReception(fojaId, payload = {}) {
  const response = await api.post(`/api/fojas/${fojaId}/recepcion/cerrar`, payload);
  return unwrap(response);
}

export async function validateFojaQr(payload) {
  const response = await api.post('/api/fojas/qr/validar', payload);
  return unwrap(response);
}

export async function registerFojaScan(payload) {
  const response = await api.post('/api/fojas/scans', payload);
  return unwrap(response);
}

export async function getFojaAppSummary(fojaId) {
  const response = await api.get(`/api/fojas/${fojaId}/app/resumen`);
  return unwrap(response);
}

export async function getPendingScans(fojaId) {
  const response = await api.get(`/api/fojas/${fojaId}/pendientes-scan`);
  return unwrap(response);
}

export async function confirmMobileReception(payload) {
  const response = await api.post('/api/fojas/app/confirmar-recepcion', payload);
  return unwrap(response);
}
